"use strict";
/**
 * extracted from utilities - normalizeBids 2167
 * file is fine, same as prod.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeBids = void 0;
var getBidPrices_1 = require("./getBidPrices");
/**
 * normalizeBids
 * Takes in a set of bids from Prebid or IX and converts them to a standard format
 *
 * @param {array} bids List of bids
 * @param {object} bidformat Call to utils.getBidFormat (supports "prebid" only)
 * @return array of normalized bids
 * each normalized bid will have the following props:
 * id: atha bid id, if present in the source bid
 * source_bid: The original bid with all fields
 * dimensions: string dimensions of bid creative, ex "728x90"
 * partner: string of partnerId
 * bic: bid in cents (cpm expressed in cents, 1)
 * cpi: cost per impression (0.00001)
 * cpm: cost per 1000 impressions (0.01)
 */
function normalizeBids(bids, bidFormat) {
    var normalizedBids = [];
    bids.forEach(function (bid) {
        normalizedBids.push(__assign({ id: bid.id, source_bid: bid, dimensions: Array.isArray(bid.size) ? bid.size.join("x") : bid.size, partner: bid[bidFormat.bidderField] }, (0, getBidPrices_1.getBidPrices)(bid[bidFormat.priceField], bidFormat.priceIncrement)));
    });
    return normalizedBids;
}
exports.normalizeBids = normalizeBids;
